var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 50711"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z",
    "data-name": "Rectangle 16356"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.159 20.342h1.8v-6.031l2.46 2.46 1.26-1.26-4.68-4.56-4.62 4.62 1.26 1.26 2.52-2.52ZM4.198 24a1.727 1.727 0 0 1-1.26-.54 1.727 1.727 0 0 1-.54-1.26V1.8a1.727 1.727 0 0 1 .54-1.26A1.727 1.727 0 0 1 4.198 0h10.831L21.6 6.571V22.2a1.727 1.727 0 0 1-.54 1.26 1.727 1.727 0 0 1-1.26.54Zm9.931-16.621V1.8H4.198v20.4h15.6V7.379ZM4.198 1.8Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.82e4c190b4ff794bbe66f44f24be8d75.svg";
export { ForwardRef as ReactComponent };